<template>
  <div>
    <slot name="activator" :toggle="toggle"></slot>
    <v-bottom-sheet
      :value="isOpen"
      :max-width="maxAppWidth"
      class="pt-0"
      scrollable
      @click:outside="close"
    >
      <v-card rounded="xl b-0" min-height="200px">
        <v-card-title
          class="d-flex justify-space-between align-center pa-4"
          :style="{
            'border-bottom': hasScrolled ? '1px solid #E0E0E0' : 'none',
          }"
        >
          <div class="tp-text-subtitle-semibold">
            <v-fade-transition>
              <span>
                {{ title }}
              </span>
            </v-fade-transition>
          </div>
          <img
            :src="require(`@/assets/images/icons/chevron-down-white-icon.svg`)"
            @click="close"
          />
        </v-card-title>
        <v-card-text
          ref="scrollContainer"
          height="500px"
          class="px-4 pb-9"
          @scroll="handleScroll"
        >
          <LeaveReview
            :tips-qr-card-hash="tipsQrCardHash"
            :unique-order-number="uniqueOrderNumber"
            hide-title
            class="mt-1"
            :payment-uuid="paymentUuid"
            :session="session"
            :google-place-id="googlePlaceId"
            :instant-google-reviews-redirect="instantGoogleReviewsRedirect"
            @rating-submitted="handleRatingSubmitted"
          />
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import LeaveReview from '@/components/Reviews/Review.vue';

export default {
  components: {
    LeaveReview,
  },
  props: {
    uniqueOrderNumber: {
      type: String,
      required: false,
      default: null,
    },
    tipsQrCardHash: {
      type: String,
      required: false,
      default: null,
    },
    paymentUuid: {
      type: String,
      required: false,
      default: null,
    },
    session: {
      type: String,
      required: false,
      default: null,
    },
    googlePlaceId: {
      type: String,
      required: false,
      default: null,
    },
    instantGoogleReviewsRedirect: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      hasScrolled: false,
      title: this.$t('components.review.title'),
    };
  },
  methods: {
    close() {
      this.isOpen = false;
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },
    handleScroll(event) {
      this.hasScrolled = event.target.scrollTop > 10;
    },
    handleRatingSubmitted() {
      // this.isOpen = false;
      this.title = this.$t('components.review.thankYouTitle');
      this.$emit('rating-submitted');
    },
  },
};
</script>
